import React from 'react'
import classnames from 'classnames'
import s from './ToggleFullScreenGeButton.less'
import { useAction, withEverySelectorTruthy } from '../../utils/react-redux'
import { toggleFullscreen } from '../../../store/map/map.actions'
import useEventCallback from '../../utils/useEventCallback'
import { withOnlyGE } from '../../Device'
import ReduireDesktop from './reduire-desktop.svg'
import SVGIcon from '../../svg/SVGIcon'
import { selectIsMapFullScreen, selectShouldDisplayToggleFullScreenGeButton } from '../../../store/map/map.selectors'
import { useSelector } from 'react-redux'
import { ACTION } from '../../analytics/ClickTagsService'
import TagActionButton from '../../genericComponents/TagActionButton'
import { TAG_CLICK_TOGGLE_FULLSCREEN } from '../../../store/analytics/analytics.actionTypes'

const ToggleFullScreenGeButton = () => {
  const execToggleFullScreen = useAction(toggleFullscreen)
  const isMapFullScreen = useSelector(selectIsMapFullScreen)

  const onClick = useEventCallback(() => {
    execToggleFullScreen()
  }, [execToggleFullScreen])

  return (
    <TagActionButton
      className={s.container}
      type={TAG_CLICK_TOGGLE_FULLSCREEN}
      tagInfo={{ [ACTION]: isMapFullScreen ? 'Ouvrir' : 'Fermer' }}
      onClick={onClick}
    >
      <SVGIcon url={ReduireDesktop} className={classnames(s.icon, isMapFullScreen ? s.invert : undefined)} />
    </TagActionButton>
  )
}

export default withOnlyGE(
  withEverySelectorTruthy(selectShouldDisplayToggleFullScreenGeButton)(ToggleFullScreenGeButton)
)
